<template>
  <div>
    <!-- NAVBAR -->
    <my-navbar :controller="controller"/>
    <!-- HEADER -->
    <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row justify-content-md-center mb-2">
            <div class="col-md-10">
              <div class="row">
                <div class="col-md-3 col-sm-4">
                  <div class="card card-stats mb-4 mb-lg-0">
                    <div class="card-body">
                      <div class="row">
                        <div class="col">
                          <h5 class="card-title text-uppercase text-muted mb-0">Datos baneados</h5>
                          <span class="h2 font-weight-bold mb-0">{{this.baneados.length}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-1"></div>
            <div class="col-sm-4">
              <div class="form-group mb-1 mt-4">
                  <input type="text" class="form-control form-control-alternative" placeholder="Buscar por contenido" v-model="searchInput" :disabled="loading">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="container-fluid mt--7 mt-2">

      <div class="row justify-content-md-center">
        <div class="col-md-10">

          <!-- COMPONENTE PRINCIPAL -->
          <div class="card shadow">

            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0"><b-spinner class="small" variant="primary" v-if="loading" /> Datos baneados</h3>
               </div>
                <div class="col text-right">
                  <select v-model="countOfPage" @change="limiteRecords" class="form-control form-control-alternative" style="max-width:100px;display:inline;" :disabled="loading">
                    <option value="10">10</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row sticky  shadow" v-if="actions.post">
              <div class="col-md-12">
                <!-- Filtro -->
                <div class="card card-body pt-4 pb-1 p-relative">
                    <p v-if="editMode" class="mt-0 text-info text-small"><i class="fa fa-edit"></i> Modo edición</p>
                    <form class="row" @submit.prevent="setBaneado">
                        <div class="col-md-3 col-sm-6">
                            <div class="form-group mb-1" :class="{ 'has-success': validBaneado }">
                                <input type="text" class="form-control form-control-alternative" placeholder="Contenido" v-model="baneado.contenido" :disabled="loading">
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <div class="form-group mb-1">
                                <select class="form-control form-control-alternative" v-model="baneado.tipo" :disabled="loading">
                                    <option class="text-muted" value="0" >Selecciona Tipo</option>
                                    <option v-for="tipo in tipos" :value="tipo.caption" :key="'tipokey_'+tipo.id">{{ tipo.caption }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <div class="form-group mb-1">
                                <select class="form-control form-control-alternative" v-model="baneado.comparador" :disabled="loading">
                                    <option class="text-muted" value="0" >Selecciona Comparador</option>
                                    <option v-for="comparador in comparadores" :value="comparador.caption" :key="'comparadorkey_'+comparador.id">{{ comparador.caption }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <div class="form-group mb-1">
                                <button type="submit" class="btn btn-success mt-1" :class="editMode ? 'btn-info':'btn-success'" v-text="editMode ? 'Actualizar':'Agregar'" :disabled="!validBaneado || loading || checkIfRecordExists"></button>
                                <button v-if="editMode" @click="closeEdit" class="btn btn-secondary mt-1" v-b-tooltip.hover title="Cerrar edición"><i class="fa fa-times"></i></button>
                            </div>
                        </div>

                    </form>
                    <div class="row" v-if="checkIfRecordExists">
                        <div class="col-sm-6" >
                          <div class="alert alert-danger fadeIn p-2 mt-3 mb-3">Este registro ya existe en el sistema</div>
                        </div>
                    </div>
                </div>
                <!-- ./Filtro -->
              </div>
            </div>

            <div class="table-responsive">
              
              <table class="table align-items-center table-flush table-hover">
                <thead class="thead-light">
                  <tr>
                    <th scope="col" class="sortItem" role="button" @click="sortItems('id')">#</th>
                    <th scope="col" class="sortItem" @click="sortItems('contenido')" style="max-width:200px;">Contenido</th>
                    <th scope="col" class="sortItem" @click="sortItems('tipo')">Tipo</th>
                    <th scope="col" class="sortItem" @click="sortItems('comparador')">Comparador</th>
                    <th scole="col" class="text-right">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="baneados.length == 0">
                    <td colspan="5" class="text-center text-muted">
                      Sin resultados
                    </td>
                  </tr>
                  <tr v-for="item in paginated('Listadotmp')" :key="item.id">
                    <th scope="row">{{item.id}}</th>
                    <td style="max-width:200px;">{{item.contenido}}</td>
                    <td> {{ item.tipo }}</td>
                    <td> {{ item.comparador }}</td>
                    <td class="text-right">
                      <button v-if="actions.put" type="button" class="btn btn-info" @click="toggleEdit(item)" :disabled="loading || editMode && baneado.id == item.id"><i class="fa fa-edit"></i></button>
                      <button v-if="actions.delete" type="button" class="btn btn-outline-danger" @click="deleteBaneado(item, indexItem)" :disabled="loading || editMode && baneado.id == item.id"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="card-body">
                <paginate
                  name="Listadotmp"
                  :list="Listadotmp"
                  :per="countOfPage"
                  tag="tr"
                  class="d-none"
                ></paginate>
            </div>

            <div class="card-footer">
               <paginate-links
                    :async="true"
                    for="Listadotmp"
                    :show-step-links="true"
                    :limit="5"
                    class="v-paginate v-paginate-justify"
                    :hide-single-page="true"
                ></paginate-links>
            </div>

          </div>
        </div>

        <!-- <div class="col-md-4">
          <div class="card shadow">
            <div class="card-body p-1">
              <div class="nav-wrapper">
                <ul class="nav nav-pills nav-fill flex-column flex-md-row" id="tabs-icons-text" role="tablist" >
                  <li class="nav-item">
                    <a class="nav-link mb-sm-3 mb-md-0 active" id="tabs-icons-text-1-tab" data-toggle="tab" href="#tabTipos" role="tab" aria-controls="tabs-icons-text-1" aria-selected="true">Tipos</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link mb-sm-3 mb-md-0" id="tabs-icons-text-2-tab" data-toggle="tab" href="#tabComparadores" role="tab" aria-controls="tabs-icons-text-2"  >Comparadores</a>
                  </li>
                </ul>
              </div>
              <div class="tab-content">
                <div class="tab-pane fade show active" id="tabTipos" role="tabpanel" aria-labelledby="tabs-icons-text-1-tab" >

                    Componente Tipos :actions="actions"

                </div>
                <div class="tab-pane fade" id="tabComparadores" role="tabpanel" aria-labelledby="tabs-icons-text-2-tab" >

                    Componente Comparadores :actions="actions"

                </div>
              </div>
            </div>
          </div>
        </div> -->

        
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import _ from 'underscore'
import Auth from '@/helpers/middleware'
import sysMsg from '@/helpers/system.message'
import { mapActions, mapGetters } from 'vuex'
import baneadosServices from '@/services/baneados.services'
import { Baneado } from '@/views/operaciones/baneados/models/baneados.model.js'

import Tipos from '@/views/operaciones/baneados/_tipos'
import Comparadores from '@/views/operaciones/baneados/_comparadores'

export default {
  name: "baneados",
  components: {
    Tipos, Comparadores
  },
  data() {
    return {
      loading: false,
      searchInput: "",
      countOfPage: 10,
      paginate: ['Listadotmp'],
      controller: {
        title: "Baneados",
        mainRouter: "baneados"
      },
      tmp: [],
      actions: Auth.getActions(this.$route.name),
      baneados: [],
      baneado: new Baneado()
    }
  },
  computed: {
    ...mapGetters('baneados', ['tipos', 'comparadores']),
    validBaneado() {
      return this.baneado.contenido.toString().trim().length > 0 && this.baneado.tipo != 0 && this.baneado.comparador != 0 
    },
    editMode(){
      return this.baneado.id > 0;
    },
    checkIfRecordExists() {
      var obj = this.baneado;
      return this.baneados.filter(item => item.contenido == obj.contenido.toString().trim() &&  item.tipo == obj.tipo && item.comparador == obj.comparador && item.id > obj.id).length > 0
    },
    Listadotmp(status) {
      
      let search = this.searchInput;

/*       if(search.toString().trim().length < 5) {
        return this.tmp
      } */

      let cloneTMP = _.clone(_.filter(this.tmp, function (filter) {
        return (filter.contenido.toString().trim().toLowerCase().indexOf(search.toString().trim().length > 4 ? search.toString().trim().toLowerCase() : filter.contenido.toString().trim().toLowerCase()) > -1);
      }));

      this.paginate.Listadotmp.list = cloneTMP.length == 0 ? this.tmp : cloneTMP;
      this.paginate.Listadotmp.page = 0;

      return cloneTMP;

    }
  },
  created() {
    this.initData()
  },
  methods: {
    ...mapActions('baneados', ['getTipos', 'setTipo',  'removeTipo', 'getComparadores', 'setComparador',  'removeComparador']),
    limiteRecords() {
      this.countOfPage = parseInt(this.countOfPage);
    },
    initData() {
      let _this = this;
      axios.all([this.getTipos(), this.getComparadores()]).then(()=> {
          _this.getBaneados();
      });
    },
    getBaneados() {
      this.loading = true;
      baneadosServices.baneados.getAll().then(response => {
        this.baneados = _.sortBy(response.data, sort => sort.id).reverse()
        this.tmp = _.sortBy(response.data, sort => sort.id).reverse()
        this.loading = false;
      }).catch(error => {
        sysMsg.getResponseMessage(error.response);
        this.loading = false;
      })
    },
    setBaneado() {
      this.loading = true;
      baneadosServices.baneados.set(this.baneado).then(response => {
        if(this.baneado.id > 0) {
          sysMsg.getMessage('Baneado actualizado con éxito', 'info')
          this.loading = false;
          return
        }

        this.baneado = new Baneado();
        this.baneados.push(response.data);
        this.baneados = _.sortBy(this.baneados, sort => sort.id).reverse()
        this.tmp = this.baneados;
        this.loading = false;
        sysMsg.getMessage('Baneado agregado con éxito', 'success')
        
      }).catch(error => {
        sysMsg.getResponseMessage(error.response);
        this.loading = false;
      }) 
    },
    deleteBaneado(item, index){
      sysMsg.getConfirm("Confirmar eliminación", "")
        .then(result => {
          if (result.value) {
            this.loading = true;
            baneadosServices.baneados.remove(item).then(() => {
              this.baneados.splice(index, 1);
              this.tmp = this.baneados;
              this.loading = false;
              sysMsg.getMessage('Baneado eliminado con éxito', 'warning')        
            }).catch(error => {
              sysMsg.getResponseMessage(error.response);
              this.loading = false;
            });
          }
        });
    },
    toggleEdit(item) {
      this.baneado = item
    },
    closeEdit() {
      this.baneado = new Baneado();
    },
    sortItems(by) {
      if( this.tmpFilter == by) {
        this.baneados = _.sortBy(this.baneados, sort => sort[by]).reverse();  
        this.tmpFilter = '';
      } else {
        this.tmpFilter = by;
        this.baneados = _.sortBy(this.baneados, sort => sort[by]);
      }
    }
  }
};
</script>

<style scoped>
.card .table td, .card .table th {
    padding-left: 1rem;
    padding-right: 1rem;
    padding: .5rem;
}
.elem-disabled {
  pointer-events: none;
}
.sticky {
    position: sticky;
    top: 20px;
    z-index: 10;
}
/* .sortItem {
  cursor: pointer;
} 
.sortItem:hover,
.sortItem:focus {
  text-decoration: underline;
}*/
.editMode > td,
.editMode > th {
  background-color: #d0f3f9;
}
</style>

